/** @prettier */
import React, { Component } from "react";
import "./HomeDashboard.css";

class HomeDashboard extends Component {
    render() {
        return (
            <div className="home-dashboard">
                <h3 className="dashboard-header">Dashboard - Welcome</h3>
                <span className="dashboard-body">
                    Dashboard features coming soon...
                </span>
            </div>
        );
    }
}

export default HomeDashboard;
